const proxy = `https://mattiasassets.com/`;
// const proxy =  `http://mattias.local/`;
export default proxy;